import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/Card"
import type { Market } from "@/lib/useMarket"
import { MarketFlag } from "./MarketSelect"

type Props = { pageLabel: string; markets: Market[]; onPick: (market: Market) => void }

// Shown in place of a market page when no market has been picked yet this
// session. Picking one opens the page and is remembered for the next ones.
export default function MarketPicker({ pageLabel, markets, onPick }: Props) {
  return (
    <div className="flex justify-center pt-12">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Which market?</CardTitle>
          <CardDescription>Pick the market to open {pageLabel} for. You can switch any time from the top of the page.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          {markets.map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => onPick(m)}
              className="flex items-center gap-3 rounded-md border border-border px-4 py-3 text-left text-sm font-medium text-foreground transition-colors hover:bg-muted"
            >
              <MarketFlag market={m} />
              {m.name}
              <span className="ml-auto text-xs text-muted-foreground">{m.currency}</span>
            </button>
          ))}
        </CardContent>
      </Card>
    </div>
  )
}
